export default {
  AMIRI: 'Amiri',
  ARNO_PRO: 'ArnoPro',
  CABIN: 'Cabin',
  CABIN_BOLD: 'CabinBold',
  DYSLEXIC: 'Dyslexic',
  GARAMOND_1689: 'Garamond1689',
  GENTIUM: 'Gentium',
  GOUDY_HANDTOOLED: 'GoudyHandtooled',
  MARCO_POLO: 'MarcoPolo',
  // NUNITO_SANS: 'NunitoSans',
  ROMANTIK: 'Romantik',
  SANCHEZ: 'Sanchez',
  SPECIAL_ELITE: 'SpecialElite',
  TYPEWRITTER: 'Typewriter'
};
